export default class EditRegisterContactViewState {
  isVisible = false;
}
